// @import_dependencies
import { store } from 'app_storage/redux-storage'
// @end

// @import services
// @end

// @import utilities
import { Http, HttpCustomStructure } from 'app_utils/http'
import { ScreenNotificationsUtil } from 'app_utils/screenNotification'
// @end

// @import types
import {
  ICertificationForceHttpResponse,
  ICourseSchedulingEnrollmentHttpResponse,
  ICourseSchedulingEnrollmentsHttpResponse,
  IDownloadMasiveCertificationsHttpResponse,
  IEnrollmentInsertOrUpdateParams,
  IFetchCertificationsDataHttpResponse,
  IGenerateCertifications,
} from 'app_types/admin/courseScheduling/courseSchedulingEnrollmentTypes'
import { IHttpResponse } from 'app_types/httpTypes'
// @end

class CourseSchedulingEnrollmentService {

  private token: string
  private storeObject: any
  private Http: any
  private screenNotification: ScreenNotificationsUtil

  /*===============================================
  =            Estructura de un metodo            =
  ================================================
    // La estructura de un metodo debe ser la siguiente:
    public methodName = () => {}
  /*======  End of Estructura de un metodo  =====*/

  constructor() {
    this.Http = Http
    this.storeObject = store
    this.screenNotification = new ScreenNotificationsUtil()
  }

  refreshAuthToken = () => {
    let auth = this.storeObject.getState().auth
    this.token = (auth.user?.token) ? auth.user.token : ''
  }

  async list(params: any = {}) {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingEnrollmentsHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/enrollment`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  async certificateQueue(params: any = {}) {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingEnrollmentsHttpResponse

    console.log('Params to request:')
    console.log(params)
    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate/completion`,
      auth_token: this.token,
      params: {
        ...params,
      },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }


  insertOrUpdate = async (postData: IEnrollmentInsertOrUpdateParams, action: string = 'create') => {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingEnrollmentHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/enrollment/${action}`,
      auth_token: this.token,
      params: { ...postData },
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  getOne = async (id: string) => {
    this.refreshAuthToken()

    let responseData: ICourseSchedulingEnrollmentHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'GET',
      url: `/api/enrollment/${id}`,
      auth_token: this.token,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData.enrollment
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  remove = async (id: string) => {
    this.refreshAuthToken()

    let responseData: IHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'DELETE',
      url: `/api/enrollment/delete/${id}`,
      auth_token: this.token,
      params: {
        sendMail: true
,      }
,    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return true
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  generateCertifications = async (data: any) => {
    this.refreshAuthToken()

    let responseData: IGenerateCertifications

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificateQueue/create`,
      auth_token: this.token,
      params: { ...data },
    }

    responseData = await this.Http.send(queryData)
    if (responseData.code === 200) {
      return responseData.certificateQueue
    } else {
      this.screenNotification.fire(responseData)
    }

    return null
  }

  fetchCertificationsData = async (params: any, options: { showError: boolean } = { showError: true }) => {
    this.refreshAuthToken()

    let responseData: IFetchCertificationsDataHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/enrolledCourse/fetch-certifications`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

  downloadMasiveCertifications = async (params: any, options: { showError: boolean } = { showError: true }) => {
    this.refreshAuthToken()

    let responseData: IDownloadMasiveCertificationsHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/data/enrolledCourse/download-masive-certifications`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

  findStudents = async (params: any) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/enrollment/find-students`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      this.screenNotification.fire(responseData)
    }

    return false
  }

  certificationForceProcess = async (params: any, options: { showError: boolean } = { showError: true }) => {
    this.refreshAuthToken()

    let responseData: ICertificationForceHttpResponse

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/admin/certificate/force-stage`,
      auth_token: this.token,
      params,
    }

    responseData = await this.Http.send(queryData)

    if (responseData.code === 200) {
      return responseData
    } else {
      if (options && options.showError) this.screenNotification.fire(responseData)
    }

    return false
  }

  getCurrentStatus = async ({ enrollmentId }: { enrollmentId: string }) => {
    this.refreshAuthToken()

    let responseData: any

    const queryData: HttpCustomStructure = {
      method: 'POST',
      url: `/api/enrollment/get-current-enrollment-status`,
      auth_token: this.token,
      params: { enrollmentId },
    }

    responseData = await this.Http.send(queryData)

    return responseData
  }

}

export default CourseSchedulingEnrollmentService
